import { selectParentNode, joinUp, joinDown, lift, baseKeymap, deleteSelection, joinBackward, selectNodeBackward, newlineInCode, liftEmptyBlock, splitBlock, createParagraphNear, } from 'prosemirror-commands';
import { undo, redo } from 'prosemirror-history';
import { undoInputRule } from 'prosemirror-inputrules';
import { insertText } from '../commands/insertText.js';
import { deleteTextBeforeCursor } from '../commands/deleteTextBeforeCursor.js';
import { resetLeadingTextBlock } from '../commands/resetLeadingTextBlock.js';
import { createParagraphAfterSelectedBlock, createParagraphBeforeSelectedBlock, } from '../commands/createParagraphAroundSelectedBlock.js';
import { createParagraphInheritAttrs } from '../commands/createParagraphInheritAttrs.js';
import { captureBackspaceFromAfter } from '../commands/captureBackspaceFromAfter.js';
import { tailGapcursorBackspace } from '../commands/tailGapcursorBackspace.js';
import { getRequestIdle, getCancelIdle } from '../utils/idle.js';
const justPreventDefault = () => true;
class BuiltInPlugin {
    constructor(name, capabilities, priority = 0) {
        this.name = name;
        this.capabilities = capabilities;
        this.priority = priority;
    }
    initEditor() { }
}
export const createBuiltInPlugins = () => [
    // 基础快捷键，低优先级
    new BuiltInPlugin('ex:builtInShortCuts', () => ({
        shortcuts: {
            ...baseKeymap,
            Enter: [
                newlineInCode,
                createParagraphAfterSelectedBlock,
                createParagraphNear,
                liftEmptyBlock,
                createParagraphInheritAttrs,
                splitBlock,
            ],
            'Shift-Enter': createParagraphBeforeSelectedBlock,
            Tab: insertText('\t'),
            'Shift-Tab': justPreventDefault,
            'Mod-z': undo,
            'Shift-Mod-z': redo,
            'Mod-y': redo,
            Backspace: [
                resetLeadingTextBlock,
                deleteSelection,
                captureBackspaceFromAfter,
                tailGapcursorBackspace,
                joinBackward,
                selectNodeBackward,
            ],
            Escape: selectParentNode,
            'Alt-ArrowUp': joinUp,
            'Alt-ArrowDown': joinDown,
            'Mod-BracketLeft': lift,
        },
    })),
    // 高优先级快捷键
    new BuiltInPlugin('ex:builtInShortCuts2', () => ({
        shortcuts: {
            'Shift-Tab': deleteTextBeforeCursor('\t'),
            Backspace: undoInputRule,
        },
    }), 99),
    new (class IdleChangeEmitter {
        constructor() {
            this.name = 'ex:builtInIdleChangeEmitter';
            this.changeEvt = null;
            this.idleId = 0;
            this.requestIdle = getRequestIdle();
            this.cancelIdle = getCancelIdle();
            this.emit = () => {
                const { changeEvt } = this;
                // 考虑 idlechange listeners 可能再递归触发 change，
                // 这里要先清掉旧数据再 emit
                this.idleId = 0;
                this.changeEvt = null;
                this.editor.emit('idlechange', changeEvt);
            };
        }
        initEditor(editor) {
            this.editor = editor;
            editor.on('change', (e) => {
                var _a;
                this.changeEvt = ((_a = this.changeEvt) === null || _a === void 0 ? void 0 : _a.merge(e)) || e;
                if (this.idleId) {
                    this.cancelIdle(this.idleId);
                }
                this.idleId = this.requestIdle(this.emit);
            });
            editor.on('beforedestroy', () => {
                if (this.idleId) {
                    this.cancelIdle(this.idleId);
                    this.emit();
                }
            });
        }
    })(),
];
//# sourceMappingURL=plugins.js.map